<template>
  <div class="form-group bg-accent-table light-bordered light-radius q-pa-md">
    <p class="q-mb-xs text-14 text-primary text-font-light">{{ fieldLabel }}</p>
    <q-input
      v-model="inputModel"
      bg-color="white"
      outlined
      dense
      class="text-18"
      autofocus
      :rules="[(val) => !!val || fieldRequired]"
      :disable="isLoading || isSuggesting"
      @keyup.enter="handleSearch"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  inputValue: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
    validator: (value) => ['company', 'product'].includes(value),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isSuggesting: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:inputValue', 'search'])

const inputModel = computed({
  get: () => props.inputValue,
  set: (value) => emit('update:inputValue', value),
})
const fieldLabel = computed(() => {
  return props.type === 'company' ? 'Enter company name' : 'Enter product name'
})

const fieldRequired = computed(() => {
  return props.type === 'company' ? 'Company name is required' : 'Product name is required'
})

const handleSearch = () => {
  if (props.type === 'company' && props.inputValue) {
    emit('search')
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  gap: 0.5rem;
  margin-bottom: 1rem;
  box-shadow: inset 0 0 5px 1px rgba(1, 1, 1, 0.061);
}
</style>
